/*
 * Source: https://github.com/lodash/lodash/issues/723#issuecomment-443403094
 */
import { isNil } from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const omitDeep = (input = null, excludes = null) => {
  if (isNil(input) || isNil(excludes)) return input;
  return Object.entries(input)
    .reduce((nextInput, [key, value]) => {
      const shouldExclude = excludes.includes(key);
      if (shouldExclude) return nextInput;

      if (Array.isArray(value)) {
        const arrValue = value;
        const nextValue = arrValue.map((arrItem) => {
          if (typeof arrItem === 'object') {
            return omitDeep(arrItem, excludes);
          }
          return arrItem;
        });
        nextInput[key] = nextValue;
        return nextInput;
      } else if (typeof value === 'object') {
        nextInput[key] = omitDeep(value, excludes);
        return nextInput;
      }

      nextInput[key] = value;

      return nextInput;
    }, {});
};



// WEBPACK FOOTER //
// ./src/lib/util/omitDeep.js